var React = require('react');

function DownloadIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 6.74421H10V0.77832H4V6.74421H0L7 13.7044L14 6.74421ZM0 15.693V17.6817H14V15.693H0Z","fill":"#F6F7F9"}));
}

DownloadIcon.defaultProps = {"width":"14","height":"18","viewBox":"0 0 14 18","fill":"none"};

module.exports = DownloadIcon;

DownloadIcon.default = DownloadIcon;
